//import DashboardComponent from './Dashboard';
import CardWithIcon from "./Dashboard"

export const Dashboard = CardWithIcon;
